import { render } from "./NotificationPreviewDialog.vue?vue&type=template&id=40d79f86&scoped=true"
import script from "./NotificationPreviewDialog.vue?vue&type=script&lang=js"
export * from "./NotificationPreviewDialog.vue?vue&type=script&lang=js"

import "./NotificationPreviewDialog.vue?vue&type=style&index=0&id=40d79f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d79f86"]])

export default __exports__